import ky from 'ky';
import { ENV } from 'src/utils/env';
import { getHeadersWithBearerToken } from 'src/utils/get-auth-with-bearer';
import { ORG_DATA_SCHEMA } from './types-and-schema';
import { transformDataFn } from './transform-data-fn';

export const getOrgsPromise = async () => {
  try {
    const headers = getHeadersWithBearerToken();

    const response = await ky.get(`${ENV.API_URL}/org/`, { headers }).json();

    const validatedResponse = ORG_DATA_SCHEMA.safeParse(response);

    if (!validatedResponse.success) {
      throw new Error('Failed to fetch orgs');
    }

    return transformDataFn(
      validatedResponse.data.orgs.map((org) => ({
        ...org,
        devices: org.devices
          .map((device) => ({
            ...device,
            org: org.name,
          }))
          .sort((a, b) => a.name.localeCompare(b.name)),
      }))
    );
  } catch (error) {
    console.error('Error fetching orgs:', error);
    return {
      totalOrgsCount: 0,
      totalDevicesCount: 0,
      totalActiveDevicesCount: 0,
      totalInactiveDevicesCount: 0,
      paginatedAllDevices: {
        orgs: [],
        totalPages: 0,
      },
      paginatedActiveDevices: {
        orgs: [],
        totalPages: 0,
      },
      paginatedInactiveDevices: {
        orgs: [],
        totalPages: 0,
      },
      searchAutoComplete: [],
    };
  }
};
